module.exports = __webpack_public_path__ + "static/img/background.16bca327.svg";